import React from 'react';
import * as LucideIcons from 'lucide-react';

/**
 * Maps admin-provided color key → Tailwind classes.
 * Keep the palette constrained to colors that already exist in the app.
 */
const COLOR_CLASSES = {
  cyan: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  amber: 'bg-amber-50 text-amber-700 border-amber-200',
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  purple: 'bg-purple-50 text-purple-700 border-purple-200',
  blue: 'bg-blue-50 text-blue-700 border-blue-200',
  rose: 'bg-rose-50 text-rose-700 border-rose-200',
  orange: 'bg-orange-50 text-orange-700 border-orange-200',
  slate: 'bg-slate-100 text-slate-700 border-slate-200',
};

const toPascal = (s) =>
  (s || 'award')
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join('');

const resolveIcon = (name) => {
  const key = toPascal(name);
  return LucideIcons[key] || LucideIcons.Award;
};

export const BadgePill = ({ badge, size = 'md' }) => {
  const Icon = resolveIcon(badge?.icon);
  const colorClasses = COLOR_CLASSES[badge?.color] || COLOR_CLASSES.cyan;
  const sz = size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm';
  const iconSize = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';

  return (
    <span
      data-testid={`credibility-badge-${badge?.badge_id || badge?.name}`}
      className={`inline-flex items-center gap-1.5 border rounded-full font-bold ${sz} ${colorClasses}`}
      title={badge?.description || ''}
    >
      <Icon className={iconSize} />
      {badge?.name}
    </span>
  );
};

const BadgeDisplay = ({ badges, size = 'md', className = '' }) => {
  if (!badges || badges.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="badge-display">
      {badges.map((b) => (
        <BadgePill key={b.badge_id} badge={b} size={size} />
      ))}
    </div>
  );
};

export default BadgeDisplay;
